import React, { Component } from 'react';
import classNames from 'classnames';

import './styles.css';
import SimpleMarkdown from '../SimpleMarkdown';

/**
 * An app notification component.
 *
 * @typedef {Object} Props
 * @prop {String} [className]
 * @prop {String} [buttonLabel]
 * @prop {Function} [onClick]
 *
 * @augments {Component<Props>}
 */
export default class AppNotification extends Component {

	genClassName = (props) => classNames('AppNotification', props.className);

	/** @param {React.SyntheticEvent} event */
	handleClick = (event) => this.props.onClick && this.props.onClick(event);

	render () {
		return (
			<div role='alert' className={this.genClassName(this.props)}>
				<SimpleMarkdown>{this.props.children}</SimpleMarkdown>
				<button onClick={this.handleClick} className='AppNotification-button'>
					{this.props.buttonLabel}
				</button>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/AppNotification/AppNotification.js